export default class Const {
  static marboTid = "100002055";
  static omvTid = "101987198";
}
